/* =============================================================
   HAVENCRAFT — Laneway Collection
   Progressive-enhancement JavaScript. No dependencies.

   Three independent, self-initialising modules:
     1. Process timeline  (.js-process)
     2. Booking scheduler (.js-scheduler)
     3. FAQ accordion     (.js-faq) — single-open behaviour

   Each guards on element presence so a section can be dropped
   into a Shopify template independently.
   ============================================================= */
(function () {
  "use strict";

  /* Guard against double-initialisation if the script is enqueued more than
     once (e.g. multiple sections each rendering the shared asset snippet). */
  if (window.__lanewayInit) return;
  window.__lanewayInit = true;

  /* ---------- 1. Process timeline ---------- */
  function initProcess(root) {
    var steps   = Array.prototype.slice.call(root.querySelectorAll(".timeline__step"));
    var panels  = Array.prototype.slice.call(root.querySelectorAll(".phase-panel"));
    var progress = root.querySelector(".timeline__progress");
    var prevBtn = root.querySelector(".phase-nav-btn--prev");
    var nextBtn = root.querySelector(".phase-nav-btn--next");
    var counter = root.querySelector(".phase-nav-count");
    if (!steps.length || !panels.length) return;

    var current = 0;
    var last = steps.length - 1;

    // Wire up ARIA relationships between tabs and panels for screen readers.
    steps.forEach(function (s, idx) {
      var panel = panels[idx];
      var tabId = "laneway-phase-tab-" + idx;
      var panelId = "laneway-phase-panel-" + idx;
      s.id = tabId;
      s.setAttribute("aria-controls", panelId);
      if (panel) {
        panel.id = panelId;
        panel.setAttribute("aria-labelledby", tabId);
        panel.setAttribute("tabindex", "0");
      }
    });

    function render(i, focusTab) {
      current = Math.max(0, Math.min(last, i));
      steps.forEach(function (s, idx) {
        var active = idx === current;
        s.classList.toggle("is-active", active);
        s.classList.toggle("is-past", idx < current);
        s.setAttribute("aria-selected", active ? "true" : "false");
        s.setAttribute("tabindex", active ? "0" : "-1");
        if (active && focusTab) s.focus();
      });
      panels.forEach(function (p, idx) {
        p.classList.toggle("is-active", idx === current);
        p.hidden = idx !== current;
      });
      if (progress) progress.style.width = (current / last) * 100 + "%";
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current === last;
      if (counter) counter.textContent =
        String(current + 1).padStart(2, "0") + " / " + String(steps.length).padStart(2, "0");
    }

    steps.forEach(function (s, idx) {
      s.addEventListener("click", function () { render(idx); });
      s.addEventListener("mouseenter", function () { render(idx); });
      // Roving-tabindex keyboard nav for the tablist.
      s.addEventListener("keydown", function (e) {
        var key = e.key;
        if (key === "ArrowRight" || key === "ArrowDown") { e.preventDefault(); render(current + 1, true); }
        else if (key === "ArrowLeft" || key === "ArrowUp") { e.preventDefault(); render(current - 1, true); }
        else if (key === "Home") { e.preventDefault(); render(0, true); }
        else if (key === "End") { e.preventDefault(); render(last, true); }
      });
    });
    if (prevBtn) prevBtn.addEventListener("click", function () { render(current - 1); });
    if (nextBtn) nextBtn.addEventListener("click", function () { render(current + 1); });

    render(0);
  }

  /* ---------- 2. Booking scheduler ---------- */
  function initScheduler(root) {
    var dateBtns = Array.prototype.slice.call(root.querySelectorAll(".date-btn"));
    var timeBtns = Array.prototype.slice.call(root.querySelectorAll(".time-btn"));
    var timeStep = root.querySelector(".time-step");
    var confirm  = root.querySelector(".scheduler__confirm");
    var outDate  = root.querySelector(".js-confirm-date");
    var outTime  = root.querySelector(".js-confirm-time");
    if (!confirm) return;

    var selDate = null;
    var selTime = null;

    function refresh() {
      if (timeStep) timeStep.classList.toggle("is-disabled", !selDate);
      var ready = !!(selDate && selTime);
      confirm.classList.toggle("is-ready", ready);
      confirm.disabled = !ready;
    }

    dateBtns.forEach(function (b) {
      b.setAttribute("aria-pressed", "false");
      b.addEventListener("click", function () {
        dateBtns.forEach(function (x) { x.classList.remove("is-selected"); x.setAttribute("aria-pressed", "false"); });
        b.classList.add("is-selected");
        b.setAttribute("aria-pressed", "true");
        selDate = b.getAttribute("data-label") || b.textContent.trim();
        // reset time when date changes
        selTime = null;
        timeBtns.forEach(function (x) { x.classList.remove("is-selected"); x.setAttribute("aria-pressed", "false"); });
        refresh();
      });
    });

    timeBtns.forEach(function (b) {
      b.setAttribute("aria-pressed", "false");
      b.addEventListener("click", function () {
        timeBtns.forEach(function (x) { x.classList.remove("is-selected"); x.setAttribute("aria-pressed", "false"); });
        b.classList.add("is-selected");
        b.setAttribute("aria-pressed", "true");
        selTime = b.textContent.trim();
        refresh();
      });
    });

    confirm.addEventListener("click", function () {
      if (confirm.disabled) return;
      if (outDate) outDate.textContent = selDate;
      if (outTime) outTime.textContent = selTime;
      root.classList.add("is-confirmed");
    });

    refresh();
  }

  /* ---------- 3. FAQ — single open ---------- */
  function initFaq(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll(".faq__item"));
    items.forEach(function (item) {
      item.addEventListener("toggle", function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  /* ---------- bootstrap ---------- */
  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    document.querySelectorAll(".js-process").forEach(initProcess);
    document.querySelectorAll(".js-scheduler").forEach(initScheduler);
    document.querySelectorAll(".js-faq").forEach(initFaq);
  });
})();